<template>
  <div class="flex flex-col items-center">
    <div class="max-w-5xl lg:w-full w-5/6 lg:mx-0 mx-auto">

      <h2 class="text-2xl font-semibold py-4 border-b-2 border-red-600">
        Forecast Predictor
      </h2>
      <img
        src="../../assets/img/laptop_charts.jpg"
        alt="Forecasr Predictor Banner"
        class="w-full lg:h-96 h-80 mt-4 object-cover"
      >
      <br>
      <br>
      <div>
        Predictions for the Salary increase for the next 5 years,
        by country and by industry.
      </div>
        <br>
        <img
          src="../../assets/img/tools_forecast_predictor.png"
          alt="Forecast Predictor Banner"
          class="w-full mx-auto"
        >
        <br>
        <div>
          Predictors:
          <ul class="px-10 p-4 list-disc text-red-700">
            <li>GDP Annual Growth Rate</li>
            <li>Inflation Rate</li>
            <li>Companies Revenue Momentum</li>
            <li>Companies Cost Pressure</li>
          </ul>
        </div>
      <br>
      <br>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
export default {};
</script>
